
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon/buyback",
      function () {
        return require("private-next-pages/lon/buyback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon/buyback"])
      });
    }
  